<template lang="pug">
  transition(name='modal')
    .modal-mask(@click.self="closeModal()")
      .modal-wrapper(@click.self="closeModal()")
        .modal-container(:style="{ width: width + 'px', height: height ?  height + 'px' : 'auto'}", :class="{'container-modal': responsive}")
          div(:style="hasButtonX ? {...defaultHeaderStyle, ...headerStyle} : {...defaultHeaderStyleHasButtonX, ...headerStyleHasButtonX}")
            p.title(:style="titleStyle") {{ titulo }}
            el-button.btn#btn(
              v-if="hasButtonX"
              type="text",
              @click="triggerCloseModal()",
              @mouseover.native="hover",
              @mouseout.native="leave",
              :style="getColor",
              size="mini"
            )
              i.material-icons.icon(:style="titleStyle") close

          app-vue-perfect-scrollbar(:style="{...defaultBodyStyle, ...bodyStyle}" :settings='settings')
            slot(name="body")
          div(v-if="hasFooter")
              div(:style="{...defaultFooterStyle, ...footerStyle}")
                slot(name="footer")

</template>

<script>

import AppVuePerfectScrollbar from 'vue-perfect-scrollbar'
const defaultBodyStyle = {
  padding: '20px'
}

const defaultFooterStyle = {
  'margin-top': '10px',
  padding: '5px 20px',
  height: '60px'
}

const defaultHeaderStyle = {
  display: 'flex',
  'justify-content': 'space-between',
  'align-items': 'center',
  border: 'none',
  'border-top-left-radius': '10px',
  'border-top-right-radius': '10px',
  height: '50px',
  'background-color': '#289f61',
  'padding-left': '20px',
  'padding-right': '20px'
}

const defaultHeaderStyleHasButtonX = {
  display: 'flex',
  'justify-content': 'space-between',
  'align-items': 'center',
  border: 'none',
  'border-top-left-radius': '10px',
  'border-top-right-radius': '10px',
  height: '100px',
  'background-color': '#289f61',
  'padding-left': '20px',
  'padding-right': '20px'
}

export default {

  components: {
    AppVuePerfectScrollbar
  },

  props: {
    titulo: {
      type: String,
      required: true
    },

    width: {
      type: Number,
      default: 800
    },

    closeOutside: {
      type: Boolean,
      default: false
    },

    bodyStyle: {
      type: Object,
      default: () => defaultBodyStyle
    },

    footerStyle: {
      type: Object,
      default: () => defaultFooterStyle
    },

    headerStyle: {
      type: Object,
      default: () => defaultHeaderStyle
    },

    headerStyleHasButtonX: {
      type: Object,
      default: () => defaultHeaderStyleHasButtonX
    },

    height: {
      type: Number
    },

    hasFooter: {
      type: Boolean,
      default: true
    },

    responsive: {
      type: Boolean,
      default: false
    },

    hasButtonX: {
      type: Boolean,
      default: true
    },
    titleStyle: {
      type: Object,
      default: () => ({})
    }
  },

  data () {
    return {
      colorCopy: '#fff',
      hoverColor: '#d8d8d8',
      settings: {
        minScrollbarLength: 20,
        wheelSpeed: 1
      },
      defaultHeaderStyle,
      defaultBodyStyle,
      defaultFooterStyle
    }
  },

  computed: {
    getColor () {
      if (this.colorCopy) {
        return `color: ${this.colorCopy}`
      }
      return ''
    }
  },

  created () {
    // Corrige problema que faz a rolagem de scroll ser aplicada no background da modal
    document.body.classList.add('modal-open')
  },

  destroyed () {
    document.body.classList.remove('modal-open')
  },

  methods: {
    closeModal () {
      if (this.closeOutside) {
        this.triggerCloseModal()
      }
    },

    triggerCloseModal () {
      this.$emit('closeModal')
    },

    hover () {
      this.colorCopy = this.hoverColor
    },

    leave () {
      this.colorCopy = this.cor
    }
  }

}

</script>

<style scoped lang="scss">
.modal-mask {
  position: fixed;
  z-index: 1001;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  margin-top: 8vh;
}

.container-modal {

  @media (min-width: 320px) {
    width: 320px !important;
  }

  @media (min-width: 360px) {
    width: 360px !important;
  }

  @media (min-width: 375px) {
    width: 375px !important;
  }

  @media (min-width: 425px) {
    width: 425px !important;
  }

  @media (min-width: 768px) {
    width: 768px !important;
  }

  @media (min-width: 1366px) {
    width: 1366px !important;
  }

}

.modal-container {
  min-height: 200px;
  max-height: 87vh;
  margin: 0px auto;
  background-color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
  -moz-border-radius: 10px;
  -webkit-border-radius: 10px;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
}

@media (max-width: 780px) {
  .modal-container {
    position: relative;
    right: 20px;
    width: 350px !important;
  }

  .modal-wrapper {
    width: 410px;
  }
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: none;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  height: 50px;
  background-color: #289f61;
  padding-left: 20px;
  padding-right: 20px;
}

.modal-footer {
  margin-top: 10px;
  padding: 5px 10px;
  height: 60px;

}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.title {
  font-size: 18px;
  color: #ffffff !important;
  font-weight: bold;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin: 0 !important;
}

.title-novo {
  font-size: 18px;
  color: #ffffff !important;
  font-weight: bold;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.title-color-black {
  font-size: 18px;
  color: #222222 !important;
  font-weight: bold;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.btn-black {
  padding-right: 5px;
  color: #222222;

  .icon {
    font-size: 20px;
    color: #222222;
  }
}

.btn {
  padding-right: 5px;
  color: #ffffff;

  .icon {
    font-size: 20px;
    color: #ffffff;
  }
}

section.ps-container.ps {
  height: 100% !important;
}
</style>

<style>
body.modal-open {
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/AppModal.vue